import Instance from './instance.js'

/**
 * Represents a InstanceBoolean instance.
 * @extends Instance
 */
class InstanceBoolean extends Instance {}

export default InstanceBoolean
